export const exceptionColumns = [
    {
      field: 'exception',
      headerName: 'Exception',
      width: 150,
      editable: false,
    },
    {
      field: 'baseLocation',
      headerName: 'Base',
      width: 140,
      editable: false,
    },
    {
      field: 'equipment',
      headerName: 'Equipment',
      width: 150,
      editable: false,
    },
    {
      field: 'position',
      headerName: 'Rank',
      width: 130,
      editable: false
    },
    {
      field: 'blockMonthDates',
      headerName: 'Block Month Dates',
      width: 220,
      editable: false,
    },
    {
      field: 'pairingPostedOn',
      headerName: 'Pairing Publish',
      width: 180,
      editable: false,
      headerClassName: 'two-line',
    },
    {
      field: 'biddingClosedOn',
      headerName: 'Bidding Close',
      width: 180,
      editable: false,
      headerClassName: 'two-line',
    },
    {
      field: 'blockCloseTimeTZ',
      headerName: 'Bidding Close Time EST',
      editable: false,
      headerClassName: 'two-line',
      width: 200,
    }
  ];